/**
 * Labstep
 *
 * @module prosemirror/components/Toolbar/Experiment
 * @desc Button to insert an Experiment node
 */

import ExperimentWorkflowActionAddProtocol from 'labstep-web/components/ExperimentWorkflow/Action/AddProtocol';
import { Dropdown } from 'labstep-web/core/Dropdown';
import { NodeExperiment } from 'labstep-web/prosemirror/nodes/experiment';
import type React from 'react';
import type { IExperimentToolbarProps } from './types';

export const ExperimentToolbar: React.FC<IExperimentToolbarProps> = ({
  experimentWorkflow,
  view,
}) => (
  <ExperimentWorkflowActionAddProtocol
    experimentWorkflow={experimentWorkflow}
    viewComponent={({ toggleModal }) => (
      <Dropdown.Item
        onClick={toggleModal}
        icon="tasks"
        text="Protocol"
      />
    )}
    isModal
    onSuccess={({ response }) => {
      const { tr } = view.state;
      const node = view.state.schema.nodes[NodeExperiment.key].create(
        {
          id: response!.result,
        },
      );
      tr.setStoredMarks([]);
      tr.insert(view.state.selection.$to.pos, node);
      view.dispatch(tr);
      view.focus();
    }}
  />
);
